import { axios } from '@/services/api/axiosInstance'
import { endpoints } from '@/services/api/endpoints'
import { RootState } from '@/store/store'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

const useSaveGameData = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const gameCode = useSelector((state: RootState) => state.gameCode.gameCode)
  const gameConfig = useSelector((state: RootState) => state.gameConfig)
  const gameId = useSelector((state: RootState) => state.gameDetails.gameId)
  const coverImage = useSelector(
    (state: RootState) => state.gameDetails.coverImage
  )

  const isInitialized = useRef(false)
  const prevGameCode = useRef(gameCode)
  const prevGameConfig = useRef(gameConfig)
  const userModified = useRef(false)
  const prevCoverImage = useRef(coverImage)

  useEffect(() => {
    if (!isInitialized.current) {
      if (gameCode !== '' && Object.keys(gameConfig).length > 0) {
        isInitialized.current = true
        prevGameCode.current = gameCode
        prevGameConfig.current = gameConfig
        prevCoverImage.current = coverImage
      }
    } else {
      if (
        JSON.stringify(prevGameCode.current) !== JSON.stringify(gameCode) ||
        JSON.stringify(prevGameConfig.current) !== JSON.stringify(gameConfig) ||
        prevCoverImage.current !== coverImage
      ) {
        userModified.current = true
        saveGameData()
      }
      prevGameCode.current = gameCode
      prevGameConfig.current = gameConfig
      prevCoverImage.current = coverImage
    }
  }, [gameCode, gameConfig, coverImage])

  const saveGameData = async () => {
    if (!userModified.current) return

    setLoading(true)
    setError(null)

    const formData = new FormData()
    formData.append('game_id', gameId)
    formData.append('game_config', JSON.stringify(gameConfig))
    formData.append('cover_image', coverImage)

    const gameFile = new File([gameCode], 'game.js', {
      type: 'application/javascript',
    })
    formData.append('game_file', gameFile)

    try {
      const response = await axios.put(endpoints.saveGameData.url, formData, {
        headers: {
          accept: 'application/json',
          Authorization:
            'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhaWNhZGVzPUFJU2VydmVyIn0.CExlDZ3TYVhEfGvde7bt1gTkk4qIKnI9FIvYwhq3VbI',
          'Content-Type': 'multipart/form-data',
        },
      })
      setData(response.data)
    } catch (err) {
      setError(err.message || 'An error occurred')
    } finally {
      setLoading(false)
    }
  }

  return { saveGameData, loading, error, data }
}

export default useSaveGameData
